import { Box, CircularProgress } from "@mui/material";

export const FullPageSpinner = () => (
  <Box
    sx={{
      width1: "100%",
      height: "100%",
      position: "relative",
    }}
  >
    <CircularProgress
      sx={{
        position: "absolute",
        top: "calc(50% - 4rem)",
        left: "calc(50% - 4rem)",
      }}
      size="8rem"
    />
  </Box>
);
